/** * * Asynchronously loads the component for
ScheduleCall
* */ import { lazyLoad } from "utils/loadable";
export const ScheduleCall = lazyLoad(
  () => import("./index"),
  (module) => module.ScheduleCall
);
